import { Injectable } from '@angular/core';
import { ResponseAdapterFactory } from '../chat-response-adapter-factory';
import { DefaultAdapter } from '../adapters/default-adapter';

@Injectable()
export class ChatResponseMapperService {
  mapResponses(graphAndSummaryAgent: Record<string, any>[]): Record<string, any>[] {
    if (graphAndSummaryAgent.length === 0) {
      return [new DefaultAdapter().getFormattedResponse({ summary: null })];
    }

    return graphAndSummaryAgent.map(agent => {
      const { function_name, parameters } = agent.graph_output;
      const summary = agent.summary;
      const adapter = ResponseAdapterFactory.getAdapter(function_name);
      return adapter.getFormattedResponse({ parameters, summary });
    });
  }
}
